import axios from 'axios';
import { createSignedDeleteRequest } from 'utils/createSignedRequestsHelpers';
import { AI_AUTOMATIONS_LOCAL_API_REQUESTS } from './constants';

/** DELETE /nerobotti/automations/{id} — removes it, with no undo. */
export const deleteAutomation = async ({ automationId }) => {
  const signedRequest = await createSignedDeleteRequest({
    apiPath: `nerobotti/automations/${encodeURIComponent(automationId)}`,
    isLocalApiRequest: AI_AUTOMATIONS_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
